import {Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter} from '@angular/core';
import {WorkBindingtypeModel, WorkBindingValueModel} from './work-bindingtype.model';

@Component({
  selector: 'app-work-bindingtype-edit',
  templateUrl: './work-bindingtype-edit.component.html',
  styleUrls: ['./work-bindingtype-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WorkBindingtypeEditComponent implements OnInit {

  @Input() workBindingValue: WorkBindingValueModel;
  @Input() readonly  = false;
  @Output() changeWorkBindingValue = new EventEmitter<WorkBindingValueModel>();

  public readonly labels: WorkBindingtypeModel[] = [{
    label: 'Work on',
    value: 'start'
  }, {
    label: 'Work off',
    value: 'end'
  }
  ];
  public  current = this.labels.find(label => label.value === this.workBindingValue) || this.labels[0];
  constructor() { }

  ngOnInit() {
  }

  ngOnChanges() {
    this.current = this.labels.find(label => label.value === this.workBindingValue) || this.labels[0];
  }

  onChange(label: WorkBindingtypeModel): void {
    this.current = label;
    this.changeWorkBindingValue.emit(this.current.value);
  }

}
